import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import { fetchTopSellersGamesSection } from 'Redux/ducks/algolia-calls';
import BrowseButton from 'Components/Utility/BrowseButton';
import ProductCardCarousel from 'Components/HomePage/ProductCardCarousel';
import ItemList from 'Components/Utility/SEO/ItemList';
import HitCard from 'Components/Cards/HitCard';

const GamesSection = ({ hits, slidesToShow, isSaleLive, hideTitle }) => {
  const [gameHits, setGameHits] = useState([]);

  useEffect(() => {
    const fetchGameHits = async () => {
      const newHits = await fetchTopSellersGamesSection();
      return setGameHits(newHits);
    };

    if (isEmpty(hits)) {
      fetchGameHits();
    }
    if (!isEmpty(hits)) {
      setGameHits(hits);
    }
  }, [hits]);

  if (isEmpty(gameHits)) return false;

  return (
    <div className={classNames('games-section-carousel', { 'sale-template': isSaleLive })}>
      {!hideTitle &&
        <div className="section-heading-container">
          <h2 className="section-title"><FormattedMessage id="top-sellers-section.title" defaultMessage="Top Sellers" /></h2>
          <BrowseButton className={'view-all-btn'} location={'top-sellers'} />
        </div>
      }
      <ItemList hits={gameHits} title="Top Sellers" />

      {!isSaleLive &&
        <ProductCardCarousel
          leftAlign
          showFakeCards
          hitData={gameHits}
          slidesToShow={slidesToShow}
          viewAllLocation={'top-sellers'}
        />
      }

      {isSaleLive &&
        <ul className="HitCardsRow HitCardsRow--marginReset row">
          {gameHits.slice(0, 2).map(hit =>
            <HitCard
              key={hit.objectID}
              hit={hit}
              xsSize={6}
              smSize={6}
              mdSize={6}
              lgSize={4}
              hitCardContainerTag="li"
              hitCardNameTag="h3"
            />,
          )}

          {gameHits.slice(2, 3).map(hit =>
            <HitCard
              key={hit.objectID}
              hit={hit}
              xsSize={6}
              smSize={6}
              mdSize={4}
              lgSize={4}
              hitCardContainerTag="li"
              hitCardNameTag="h3"
            />,
          )}

          {gameHits.slice(3, 16).map(hit =>
            <HitCard
              key={hit.objectID}
              hit={hit}
              xsSize={6}
              smSize={6}
              mdSize={4}
              lgSize={3}
              hitCardContainerTag="li"
              hitCardNameTag="h3"
            />,
          )}
        </ul>
      }
    </div>
  );
};

export default GamesSection;

GamesSection.propTypes = {
  hits: PropTypes.arrayOf(PropTypes.shape({})),
  slidesToShow: PropTypes.number,
  isSaleLive: PropTypes.bool,
  hideTitle: PropTypes.bool,
};

GamesSection.defaultProps = {
  hits: [],
  slidesToShow: 4,
  isSaleLive: false,
  hideTitle: false,
};
